import { render } from "./ThirdCard.vue?vue&type=template&id=a842169e&scoped=true"
import script from "./ThirdCard.vue?vue&type=script&lang=js"
export * from "./ThirdCard.vue?vue&type=script&lang=js"

import "./ThirdCard.vue?vue&type=style&index=0&id=a842169e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a842169e"]])

export default __exports__